const ConfigurationFactory = require("../ConfigurationFactory");
const ViewerDataInfo = require("../Data/ViewerDataInfo");
const Utils = require("../Utils");
const PlaylistItemInfo = require("../Info/PlaylistItemInfo");
const PlaylistItemUtils = require("./PlaylistItemUtils");
const PresentationParser = require("../Parser/PresentationParser");
const Global = require("../Config/Global");
const Logger = require("../Logger");

const PlaylistItemController = function (placeholderInfo, playlistItem, phName, htmlName, onGadgetReady, onGadgetDone) {
  const factory = {};

  let presFrame;
  let isReady = false, isPlaying = false;

  const EMBED_SCRIPT = "<script><!--\n" +
			"try {" +
			"updateEmbed('%s1', '%s2', '%s3', '%s4');" +
			"} catch(err) { parent.writeToLog('updateEmbed call - %s3 - ' + err.message); }" +
			"\n//-->" +
			"</script>";

  const TEXT_SCRIPT = "<script><!--\n" +
			"try {" +
			"updateText('%s1', '%s2', '%s3', '%s4');" +
			"} catch(err) { parent.writeToLog('updateText call - %s3 - ' + err.message); }" +
			"\n//-->" +
			"</script>";

  const IMAGE_SCRIPT = "<script><!--\n" +
			"try {" +
			"updateImage('%s1', '%s2', '%s3', '%s4');" +
			"} catch(err) { parent.writeToLog('updateImage call - %s2 - ' + err.message); }" +
			"\n//-->" +
			"</script>";

  const IMAGE_HTML = "" +
			"<html>" +
			"<head>" +
			"<meta http-equiv=\"content-type\" content=\"text/html; charset=UTF-8\">" +
			"<title></title>" +
			"<script type=\"text/javascript\" src=\"./scripts/imageScripts.js\"></script>" +
			"<style>" +
			"	body { background-color: transparent; -moz-user-select: none; -webkit-user-select: none; -khtml-user-select: none; user-select: none; }" +
			"	#cnt {width:100%; height:100%; background-color: %s4%;}" +
			"	#wrapper {width:100%; height:100%; display:table;}" +
			"	#cell {display:table-cell; vertical-align:middle;}" +
			"	#image {display: block; margin: auto;}" +
			"</style>" +
			"<script type='text/javascript'>" +
			"var id = '%s0%';" +
			"(function() {" +
			"	window.onresize = function(event) {" +
			"		resizeImage();" +
			"	};" +
			"	window.oncontextmenu = function() {" +
			"		return false;" +
			"	};" +
			"}());" +
			"function resizeImage() {" +
			"	if (%s5%) {" +
			"		var width = Math.max(document.body.clientWidth, document.documentElement.clientWidth);" +
			"		var height = Math.max(document.body.clientHeight, document.documentElement.clientHeight);" +
			"		var img = document.getElementById('image');" +
			"		if(img.width/img.height < width/height) {" +
			"			img.style.width = 'auto';" +
			"			img.style.height = height;" +
			"		} else {" +
			"			img.style.width = '100%';" +
			"			img.style.height = 'auto';" +
			"		}" +
			"	}" +
			"}" +
			"function readyEvent() {" +
			"	var img = document.getElementById('image');" +
//			"	img.onload = function() {" +
//			"		resizeImage();" +
//			"		readyEvent();" +
//			"	};" +
			"	img.onclick = function() {" +
			"		try {" +
			"			parent.onClick(id);" +
			"		}" +
			"		catch (e) {}" +
			"	};" +
			"	img.draggable = false;" +
			"" +
			"	parent.itemReady(id, true, true, true, true, true);" +
			"}" +
			"</script>" +
			"</head>" +
			"<body style=\"margin:0px;\">" +
			"<div id=\"cnt\">" +
			"<div id=\"wrapper\">" +
			"<div id=\"cell\">" +
			"<img id=\"image\" src=\"%s3%\" onload=\"resizeImage(); readyEvent();\" " + /* onclick=\"parent.onClick(id); */ "\">" +
			"</div>" +
			"</div>" +
			"</div>" +
			"</body>" +
			"</html>";

  const URL_SCRIPT = "<script><!--\n" +
			"try {" +
			"updateUrl('%s1', '%s2', '%s3', '%s4');" +
			"} catch(err) { parent.writeToLog('updateUrl call - %s3 - ' + err.message); }" +
			"\n//-->" +
			"</script>";

  factory.updateHtml = (presentation) => {
    if (playlistItem && PlaylistItemInfo.TYPE_PRESENTATION === playlistItem.type) {
      _updateHtmlEmbed(presentation);
    }
    else if (playlistItem && PlaylistItemInfo.TYPE_TEXT === playlistItem.type
				|| PlaylistItemInfo.TYPE_HTML === playlistItem.type) {
      _updateHtmlText(presentation);
    }
    else if (playlistItem && PlaylistItemInfo.TYPE_VIDEO === playlistItem.type) {

    }
    else if (playlistItem && PlaylistItemInfo.TYPE_IMAGE === playlistItem.type) {
      _updateHtmlImage(presentation);
    }
    else if (playlistItem && PlaylistItemInfo.TYPE_URL === playlistItem.type) {
      _updateHtmlUrl(presentation);
    }
//		else {
//			updateHtmlGadget(presentation);
//		}
  };

  let _updateHtmlEmbed = (presentation) => {
    let transition = "none";
    const embedId = playlistItem.objectData;

    let url = location.protocol + "//" + location.host + "/";

    if (url.indexOf("file") !== -1) {
      url = location.href.split("?")[0];
    }

    if (Utils.getHost() === "widgets.risevision.com") {
      const appEnv = location.pathname.startsWith("/viewer") ? location.pathname.substr(1) : "viewer/";
      url += appEnv;
    }

		// if (!Location.getParameter('gwt.codesvr'))
		// 	url += '?gwt.codesvr=127.0.0.1:9997&';
		// else
    url += "?";
    url += "type=" + ConfigurationFactory.getType() + "&id=" + embedId + "&parentId=" + presentation.id + "&scheduleId=" + ViewerDataInfo.getItemId();

    if (ConfigurationFactory.isDisplay() || ConfigurationFactory.isWebPlayer()) {
      url += "&displayId=" + ConfigurationFactory.getDisplayId();
    }

    if (ConfigurationFactory.getEnv()) {
      url += "&env=" + ConfigurationFactory.getEnv();
    }

//		int height = 0, width = 0;

//		if (placeholderInfo.getWidthUnits() === '%') {
//			width = (int)((placeholderInfo.getWidth() / 100.0) * Window.getClientWidth());
//			height = (int)((placeholderInfo.getHeight() / 100.0) * Window.getClientHeight());
//		}
//		else {
//			height = (int)placeholderInfo.getHeight();
//			width = (int)placeholderInfo.getWidth();
//		}

//		double scale = ViewerUtils.getItemScale(playlistItem.getScale());

//		height = (int)(height * scale);
//		width = (int)(width * scale);

    transition = placeholderInfo.transition;

    _addEmbedScript(presentation, url, phName, htmlName,
				transition);
  };

  let _addEmbedScript = (presentation, url, containerName, htmlName, transition) => {
    const scriptTag = EMBED_SCRIPT.replace(/%s1/g, url)
						.replace(/%s2/g, containerName)
						.replace(/%s3/g, htmlName)
						.replace(/%s4/g, transition);

    PresentationParser.addScriptTag(presentation, scriptTag);
  };

  let _updateHtmlText = (presentation) => {
    let transition = "none";
    let text = playlistItem.objectData.replace(/\n/g, "").replace(/\r/g, "");

		// Removing comments with regExp
//		var exp = '(?s)<!--.*?-->';
//		text = text.replaceAll('(?s)<!--.*?-->', '');
//		text = text.replaceAll('?s<!--.*?--\\s*>?gs', '');
//		text = text.replaceAll('(?s)<!--.*?--\\s*>?gs', '');
//		var exp = '/<!--[\\s\\S]*?-->/g';

    const exp = "<!--.*?-->";

    text = text.replace(exp, "");

//		int height = 0, width = 0;

//		if (placeholderInfo.getWidthUnits() === '%') {
//			width = (int)((placeholderInfo.getWidth() / 100.0) * Window.getClientWidth());
//			height = (int)((placeholderInfo.getHeight() / 100.0) * Window.getClientHeight());
//		}
//		else {
//			height = (int)placeholderInfo.getHeight();
//			width = (int)placeholderInfo.getWidth();
//		}

//		double scale = ViewerUtils.getItemScale(playlistItem.getScale());

//		height = (int)(height * scale);
//		width = (int)(width * scale);

    transition = placeholderInfo.transition;

    _addTextScript(presentation, text, phName, htmlName,
				transition);
  };

  let _addTextScript = (presentation, text, containerName, htmlName, transition) => {
    text = text.replace(/'/g, "\\'");

    const scriptTag = TEXT_SCRIPT.replace(/%s1/g, text)
					.replace(/%s2/g, containerName)
					.replace(/%s3/g, htmlName)
					.replace(/%s4/g, transition);

    PresentationParser.addScriptTag(presentation, scriptTag);
  };

  let _updateHtmlImage = (presentation) => {
    let transition = "none";

//		int height = 0, width = 0;

//		if (placeholderInfo.getWidthUnits() === '%') {
//			width = (int)((placeholderInfo.getWidth() / 100.0) * Window.getClientWidth());
//			height = (int)((placeholderInfo.getHeight() / 100.0) * Window.getClientHeight());
//		}
//		else {
//			height = placeholderInfo.getHeight();
//			width = placeholderInfo.getWidth();
//		}

//		double scale = ViewerUtils.getItemScale(playlistItem.getScale());

//		height = (int)(height * scale);
//		width = (int)(width * scale);

    const html = _createImageHtmlString(playlistItem.objectData);
    transition = placeholderInfo.transition;

    _addImageScript(presentation, html, phName, htmlName,
				transition);
  };

  let _createImageHtmlString = (objectData) => {
    let htmlString = IMAGE_HTML.replace(/%s0%/g, htmlName);
    htmlString = htmlString.replace(/%s3%/g, Utils.getUrlParam(objectData, "url="));
    htmlString = htmlString.replace(/%s4%/g, Utils.getUrlParam(objectData, "backgroundColor="));
    htmlString = htmlString.replace(/%s5%/g, Utils.getUrlParam(objectData, "scaleToFit="));

    return htmlString;
  };

  let _addImageScript = (presentation, html, containerName, htmlName, transition) => {
    html = html.replace(/'/g, "\\'");

    const scriptTag = IMAGE_SCRIPT.replace(/%s1/g, html)
						.replace(/%s2/g, containerName)
						.replace(/%s3/g, htmlName)
						.replace(/%s4/g, transition);

    PresentationParser.addScriptTag(presentation, scriptTag);
  };

  let _updateHtmlUrl = (presentation) => {
    let transition = "none";
    const url = playlistItem.objectData;

//		int height = 0, width = 0;

//		if (placeholderInfo.getWidthUnits() === '%') {
//			width = (int)((placeholderInfo.getWidth() / 100.0) * Window.getClientWidth());
//			height = (int)((placeholderInfo.getHeight() / 100.0) * Window.getClientHeight());
//		}
//		else {
//			height = (int)placeholderInfo.getHeight();
//			width = (int)placeholderInfo.getWidth();
//		}

//		double scale = ViewerUtils.getItemScale(playlistItem.getScale());

//		height = (int)(height * scale);
//		width = (int)(width * scale);

    transition = placeholderInfo.transition;

    const scriptTag = URL_SCRIPT.replace(/%s1/g, url)
						.replace(/%s2/g, phName)
						.replace(/%s3/g, htmlName)
						.replace(/%s4/g, transition);

    PresentationParser.addScriptTag(presentation, scriptTag);
  };

  factory.setReady = (frame, canPlay, canStop, canPause, canReportReady, canReportDone) => {
    presFrame = frame;

    if (!isReady) {
      isReady = true;

      if (onGadgetReady) {
        onGadgetReady();
      }

			// if GadgetReadyCommand is null, than this is a single Gadget
			// in placeholder (no ready command, just Start playing right away)
      else if (!isPlaying) {
        factory.play(true);
      }
    }
  };

  factory.setError = (presFrame, reason) => {
		// catch gadget error (not implemented)
  };

  factory.setDone = () => {
    if (isPlaying) {
      if (onGadgetDone) {
        isPlaying = false;
        onGadgetDone();
      }
      else {
        factory.stop(false);
        factory.play(false);
      }
    }
  };

  factory.play = (show) => {
    if (!isPlaying) {
      isPlaying = true;
      if (isReady) {
        Utils.playCommand(presFrame, htmlName, show);
      }
    }
  };

  factory.stop = (hide) => {
//		if (isPlaying) {
    isPlaying = false;

    Utils.stopCommand(presFrame, htmlName, hide);
//		}
  };

  factory.pause = (hide) => {
		// removed isPlaying check (since pause can be called on a 'paused' item to hide it)
//		if (isPlaying) {
    isPlaying = false;

    Utils.pauseCommand(presFrame, htmlName, hide);
//		}
  };

  factory.unload = () => {
    isReady = false;
  };

  factory.isReady = () => {
    return isReady;
  };

  factory.getItem = () => {
    return playlistItem;
  };

  (function () {
    PlaylistItemUtils.registerGadget(htmlName, factory);
  }());

  return factory;
};

module.exports = PlaylistItemController;
